var _rect, _rect2, _rect3, _rect4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbnirFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 19,
    rx: 1.5,
    fill: "#316BDB",
    stroke: "#D5D6D8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_403_28743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 23,
    height: 17,
    rx: 0.5,
    fill: "#316BDB",
    stroke: "#D5D6D8"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_403_28743)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 23.5,
    height: 17.5,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_403_28743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 18
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 23.5,
    height: 17.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_403_28743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.25,
    y: 3.59814,
    width: 3,
    height: 30.75,
    transform: "rotate(-60 -1.25 3.59814)",
    fill: "#D71F2A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 30.75,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 -1.25 16.375)",
    fill: "#D71F2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbnirFlag);
export default __webpack_public_path__ + "static/media/gbnir-flag.f12de6574e0f33a8953a126c70feb3e2.svg";
export { ForwardRef as ReactComponent };